import React from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setSelectedTag } from '../redux/app/app-slice';

const FilterComponent = () => {
    const dispatch = useAppDispatch();
    const { items, selectedTag } = useAppSelector((state) => state.app);

    const allTags = React.useMemo(() => {
        const tagSet = new Set<string>();
        items.forEach(item => {
            item.Tags.forEach(tag => tagSet.add(tag));
        });
        return Array.from(tagSet).sort();
    }, [items]);

    const handleTagChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        dispatch(setSelectedTag(event.target.value));
    };

    return (
        <div className="filter-block-filters stack-xs">
            <label htmlFor="tag-filter" className="">
                Filter by Tag:
            </label>
            <select
                id="tag-filter"
                value={selectedTag}
                onChange={handleTagChange}
                className=""
            >
                <option value="all">All Tags</option>
                {allTags.map(tag => (
                    <option key={tag} value={tag}>{tag}</option>
                ))}
            </select>
        </div>
    );
};

export default FilterComponent;